export var OrganisationCacheType;
(function (OrganisationCacheType) {
    OrganisationCacheType["TAX_RATES"] = "tax_rates";
    OrganisationCacheType["ACCOUNTS"] = "accounts";
    OrganisationCacheType["TRACKING_CATEGORIES_CLASSES"] = "tracking_categories_classes";
    OrganisationCacheType["LOCATIONS"] = "locations";
    // XERO ONLY
    OrganisationCacheType["BRANDING_THEMES"] = "branding_themes";
    OrganisationCacheType["XERO_CONTACT_GROUPS"] = "xero_contact_groups";
})(OrganisationCacheType || (OrganisationCacheType = {}));
//# sourceMappingURL=organisationResourceCache.js.map